import { SET_PAGE_STATUS } from './constants'

export const setPageStatus = payload => ({ type: SET_PAGE_STATUS, payload })
